export default defineAppConfig({
  ui: {
    colors: {
      // Vuetify's default primary was blue; only the admin login uses it
      primary: 'blue',
      neutral: 'slate',
    },
  },
});
